import { HttpClient } from '../../httpClient'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
  OpalApiRequestBody,
} from '../../schema'

type UpdateRichTextDocumentV3Operation = 'UpdateRichTextDocumentV3'
export type UpdateRichTextDocumentV3Params =
  OpalApiRequestParams<UpdateRichTextDocumentV3Operation>
export type UpdateRichTextDocumentV3RequestBody =
  OpalApiRequestBody<UpdateRichTextDocumentV3Operation>
export type UpdateRichTextDocumentV3ResponseData = OpalApiResponseDocument<
  UpdateRichTextDocumentV3Operation,
  200
>

type UpdateRichTextDocumentV3 = (args: {
  parameters: UpdateRichTextDocumentV3Params
  requestBody: UpdateRichTextDocumentV3RequestBody
}) => Promise<UpdateRichTextDocumentV3ResponseData>

export const updateRichTextDocument: UpdateRichTextDocumentV3 = async ({
  parameters,
  requestBody,
}) => {
  const url = new URL(
    `/rich_texts/v3/documents/${parameters.path.rich_text_document_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch<UpdateRichTextDocumentV3ResponseData>(url.toString(), requestBody, {
      headers: parameters.header,
    })
    .then((res) => res.data)
}
